/**
 * 获取是否是鸿蒙OSAPP
 */
export function getAppInfo() {
  return new Promise((resolve, reject) => {
    window.tjBridge.invoke({
      handleName: 'getAppInfo',
      params: {},
      success(e) {
        // 是华为鸿蒙OS
        resolve(e)
      },
      fail(e) {
        reject(e)
      }
    })
  })
}
/**
 * 获取鸿蒙OSAPP样式 状态栏高度...
 */
export function getHarmonyOSImmersive() {
  return new Promise((resolve, reject) => {
    window.tjBridge.invoke({
      handleName: 'app.immersive',
      params: {},
      success(e) {
        resolve(e)
      },
      fail(e) {
        reject(e)
      }
    })
  })
}